import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthPage from "./pages/AuthPage";
import AdminDashboard from "./pages/AdminDashboard";
import InvestorDashboard from "./pages/InvestorDashboard";
import UploadDocuments from "./pages/UploadDocuments";
import AccountDashboard from "./pages/AccountDashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/investor" element={<InvestorDashboard />} />
        <Route path="/account" element={<AccountDashboard />} />
        <Route path="/upload" element={<UploadDocuments />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;